"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventMessage = void 0;
const lodash_1 = require("lodash");
const protocol_1 = require("./protocol");
const event_emitter_1 = require("./protocol/event_emitter");
const utils_1 = require("./utils");
class EventMessage {
    constructor() {
        this.widgets = new Map();
        this.messageBridge = event_emitter_1.eventEmitter;
    }
    emit(type, data, key) {
        this.messageBridge.emit(type, { success: true, data }, key);
    }
    on(type, callback, key) {
        this.messageBridge.on(type, callback, key);
    }
    removeListenEvent(widgetId, type) {
        this.messageBridge.removeListenEvent(type, widgetId);
    }
    removeListenEventByKey(key) {
        this.messageBridge.removeListenEventByKey(key);
    }
    mountWidget(widgetId) {
        this.widgets.set(widgetId, {
            subscribeViews: []
        });
    }
    unMounted(widgetId) {
        const widget = this.widgets.get(widgetId);
        if (!widget) {
            return;
        }
        this.widgets.delete(widgetId);
        this.messageBridge.removeListenEventByKey(widgetId);
    }
    syncAction(action, widgetId) {
        this.emit(protocol_1.MessageType.MAIN_SYNC_ACTION, action, widgetId);
    }
    onSyncAction(widgetId, callback) {
        this.on(protocol_1.MessageType.MAIN_SYNC_ACTION, (0, utils_1.interceptor)(callback), widgetId);
    }
    refreshWidget(widgetId) {
        this.emit(protocol_1.MessageType.MAIN_REFRESH_WIDGET, widgetId);
    }
    onRefreshWidget(widgetId, callback) {
        this.on(protocol_1.MessageType.MAIN_REFRESH_WIDGET, (0, utils_1.interceptor)(callback), widgetId);
    }
    subscribeViews(widgetId) {
        var _a;
        if (widgetId) {
            return ((_a = this.widgets.get(widgetId)) === null || _a === void 0 ? void 0 : _a.subscribeViews) || [];
        }
        return [...this.widgets.values()].reduce((collected, item) => {
            collected.push(...item.subscribeViews);
            return collected;
        }, []);
    }
    onSyncWidgetSubscribeView(widgetId, callback) {
        this.on(protocol_1.MessageType.WIDGET_SUBSCRIBE_CHANGE, (0, utils_1.interceptor)((subscribeViews) => {
            const widget = this.widgets.get(widgetId);
            if (widget) {
                const currentSubscribeViews = widget.subscribeViews;
                this.widgets.set(widgetId, Object.assign(Object.assign({}, widget), { subscribeViews }));
                const newSubscribeViews = (0, lodash_1.differenceBy)(subscribeViews, currentSubscribeViews, ({ datasheetId, viewId }) => `${datasheetId}-${viewId}`);
                callback(newSubscribeViews);
            }
        }), widgetId);
    }
    syncWidgetSubscribeView(subscribeViews, widgetId) {
        this.emit(protocol_1.MessageType.WIDGET_SUBSCRIBE_CHANGE, subscribeViews, widgetId);
    }
    fetchDatasheet(fetchDatasheet, widgetId) {
        return this.emit(protocol_1.MessageType.WIDGET_FETCH_DATASHEET, fetchDatasheet, widgetId);
    }
    onFetchDatasheet(widgetId, callback) {
        this.on(protocol_1.MessageType.WIDGET_FETCH_DATASHEET, (0, utils_1.interceptor)(callback), widgetId);
    }
    syncCmd(cmdOptions, widgetId) {
        this.emit(protocol_1.MessageType.WIDGET_SYNC_COMMAND, cmdOptions);
        return new Promise((resolve, reject) => {
            this.on(protocol_1.MessageType.MAIN_SYNC_COMMAND_RESULT, (0, utils_1.interceptor)((res) => {
                if (res.success && res.data) {
                    resolve(res.data);
                    return;
                }
                reject(res.message);
            }), widgetId);
        });
    }
    onSyncCmdOptions(widgetId, callback) {
        this.on(protocol_1.MessageType.WIDGET_SYNC_COMMAND, (0, utils_1.interceptor)(callback), widgetId);
    }
    syncCmdOptionsResult(widgetId, cmdOptionsResult) {
        this.emit(protocol_1.MessageType.MAIN_SYNC_COMMAND_RESULT, cmdOptionsResult, widgetId);
    }
}
exports.eventMessage = new EventMessage();
